// extracted by mini-css-extract-plugin
export default {"earnRewardsSection":"NUNev31EZqExchn5g8bE","imageContainer":"qGLJx9KpA9mSnjRRatOT","labelContainer":"Qypz8zYD_oJLZwnofpYw","labelButton":"Dv2iy1Nr60sRTWYz9evw","image":"Xqvk3YmTNhSgGx9L5eeL"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"earnRewardsSection\":\"NUNev31EZqExchn5g8bE\",\"imageContainer\":\"qGLJx9KpA9mSnjRRatOT\",\"labelContainer\":\"Qypz8zYD_oJLZwnofpYw\",\"labelButton\":\"Dv2iy1Nr60sRTWYz9evw\",\"image\":\"Xqvk3YmTNhSgGx9L5eeL\"}";
        // 1755964983636
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  